import { render } from "./RuiTimer.vue?vue&type=template&id=1e06430d"
const script = {}
script.render = render

export default script